module.exports = __webpack_public_path__ + "img/grass_q90_lossy.9b44856e.webp";